module.exports = __webpack_public_path__ + "static/bread-8dcfaab5eb8558cf6edd9f7ede4387cf.jpg";